import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import cx from "classnames";
import { rem } from "polished";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Trash } from "@/components/icons/trash";
import { Tooltip } from "@/components/shared/tooltip";

import { DragVertical } from "../../../icons/drag-vertical";

const VideoContainer = styled.div<{ isDragging: boolean }>`
  position: relative;
  width: 100%;
  display: grid;
  padding: ${rem(5)} ${rem(4)};
  grid-template-columns: ${rem(16)} ${rem(56)} 1fr ${rem(16)};
  align-items: center;
  column-gap: ${rem(6)};
  height: 41px;
  border: 1px solid
    ${(props) =>
      props.isDragging ? "var(--color-gray-500)" : "var(--color-gray-300)"};
  margin-bottom: ${rem(8)};
  border-radius: ${rem(8)};
  z-index: ${(props) => (props.isDragging ? 10 : 0)};
  background-color: white;
`;

export function SortableVideoItem(props) {
  const { t } = useTranslation();
  const { video, deleteVideo } = props;
  const isPortrait = video?.aspectRatio === "9_16";

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: video.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <VideoContainer ref={setNodeRef} style={style} isDragging={isDragging}>
      <div {...attributes} {...listeners}>
        <DragVertical
          style={{
            cursor: `${isDragging ? "grabbing" : "grab"}`,
            width: rem(16),
            height: rem(16),
          }}
        />
      </div>
      <img
        src={video.thumbnail}
        alt={video.title ?? ""}
        draggable={false}
        className={cx("h-[30px] rounded-[4px]", {
          "w-full": !isPortrait,
          "w-auto max-w-full justify-self-center object-contain object-center shadow-sm ring-1 ring-black/10": isPortrait,
        })}
      />
      <Tooltip
        placement="top-center"
        tooltip={video.title}
        shouldShow={Boolean(video.title)}
      >
        <span className="inline-block max-w-40 cursor-pointer truncate text-sm leading-normal">
          {video.title}
        </span>
      </Tooltip>
      <button onClick={deleteVideo} title={t("common.delete")}>
        <Trash className="size-4" />
      </button>
    </VideoContainer>
  );
}
